import inflection from 'inflection';

const createInflection = (word, amount) =>
  `${amount} ${inflection.inflect(word, amount)}`;

export default createInflection;
